import { render, staticRenderFns } from "./checkout.component.vue?vue&type=template&id=3601cc8b&scoped=true"
import script from "./checkout.component.ts?vue&type=script&lang=ts&external"
export * from "./checkout.component.ts?vue&type=script&lang=ts&external"
import style0 from "./checkout.component.vue?vue&type=style&index=0&id=3601cc8b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3601cc8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3601cc8b')) {
      api.createRecord('3601cc8b', component.options)
    } else {
      api.reload('3601cc8b', component.options)
    }
    module.hot.accept("./checkout.component.vue?vue&type=template&id=3601cc8b&scoped=true", function () {
      api.rerender('3601cc8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/checkout/checkout.component.vue"
export default component.exports